export default {
  name: 'External applications',
  fields: {
    create: 'Create',
    addNewApplicationRule: 'Add new application rule',
    editApplicationRule: 'Edit application rule',
    applicationId: 'Application ID',
    platform: 'Platform',
    ANDROID: 'Android',
    IOS: 'iOS',
    minRequiredVersion: 'Min required version',
    recommendedVersion: 'Recommended version',
    link: 'Link',
    searchInProgress: 'Search in progress…',
    noResultsFound: 'No results found',
    tagName: 'Tag name',
  },
};
